"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.PremiumChoiceComponent = void 0;
var React = require("react");
var commonFunctions_1 = require("../../commonFunctions");
var services_1 = require("@falcon/services");
var PremiumChoiceComponent = /** @class */ (function (_super) {
    __extends(PremiumChoiceComponent, _super);
    function PremiumChoiceComponent(props) {
        return _super.call(this, props) || this;
    }
    PremiumChoiceComponent.prototype.render = function () {
        var paymentOption = this.props.interaction.factors ? this.props.interaction.factors.premiumType : undefined;
        var monthlyPremium = this.props.interaction.paymentDetails.instalmentPlan && this.props.interaction.paymentDetails.instalmentPlan.monthlyPayment;
        var annualPremium = this.props.interaction.factors.annualPremium;
        var totalPremium = this.props.interaction.paymentDetails.instalmentPlan && this.props.interaction.paymentDetails.instalmentPlan.totalAmount;
        var creditCost = this.props.interaction.paymentDetails.instalmentPlan && this.props.interaction.paymentDetails.instalmentPlan.creditCost;
        var deposit = this.props.interaction.paymentDetails.instalmentPlan && this.props.interaction.paymentDetails.instalmentPlan.deposit;
        return (React.createElement("div", { className: "premium-info no-background-color" },
            React.createElement("div", { className: "w-100" },
                React.createElement("div", { className: "payment-choice d-flex" },
                    React.createElement("div", { className: "custom-control custom-radio w-50 mx-0 pr-2" },
                        React.createElement("input", { id: "monthly", className: "custom-control-input", type: "radio", name: "payment", value: "monthly", checked: paymentOption === "monthly", onChange: this.props.onChange }),
                        React.createElement("label", { className: "custom-control-label h-100 p-2", htmlFor: "monthly" },
                            paymentOption === "monthly" ?
                                React.createElement("img", { className: "radio-circle monthly-selected", alt: "monthly selected", src: "/img/radio-circle-selected.svg" }) :
                                React.createElement("img", { className: "radio-circle monthly", alt: "monthly", src: "/img/radio-circle.svg" }),
                            React.createElement("div", { className: "font-semi-bold" }, "Monthly"),
                            React.createElement("div", { className: "price-bold pt-1 pb-2 overflow-wrap" }, (0, commonFunctions_1.getAmountWithDecimalDigits)(monthlyPremium)),
                            services_1.productHelper.isHome(this.props.interaction) && !this.props.hideDepositValue && React.createElement("div", { className: "font-light overflow-wrap" },
                                (0, commonFunctions_1.getAmountWithDecimalDigits)(deposit),
                                " deposit"),
                            React.createElement("div", { className: "font-semi-bold overflow-wrap" },
                                (0, commonFunctions_1.getAmountWithDecimalDigits)(totalPremium),
                                " ",
                                React.createElement("span", { className: "font-light" }, "in total")),
                            React.createElement("div", { className: "font-light overflow-wrap explanation-part-prefix" },
                                (0, commonFunctions_1.getAmountWithDecimalDigits)(creditCost),
                                " more than"),
                            React.createElement("div", { className: "font-light explanation-part" }, "paying annually"))),
                    React.createElement("div", { className: "custom-control custom-radio w-50 mx-0 pl-2" },
                        React.createElement("input", { id: "annual", className: "custom-control-input", type: "radio", name: "payment", value: "annual", checked: paymentOption === "annual", onChange: this.props.onChange }),
                        React.createElement("label", { className: "custom-control-label h-100 p-2", htmlFor: "annual" },
                            paymentOption === "annual" ?
                                React.createElement("img", { className: "radio-circle yearly-selected", alt: "yearly selected", src: "/img/radio-circle-selected.svg" }) :
                                React.createElement("img", { className: "radio-circle yearly", alt: "yearly", src: "/img/radio-circle.svg" }),
                            React.createElement("div", { className: "font-semi-bold" }, "Annually"),
                            React.createElement("div", { className: "price-bold pt-1 pb-2 overflow-wrap" }, (0, commonFunctions_1.getAmountWithDecimalDigits)(annualPremium))))))));
    };
    return PremiumChoiceComponent;
}(React.Component));
exports.PremiumChoiceComponent = PremiumChoiceComponent;
//# sourceMappingURL=PremiumChoiceComponent.js.map


//////////////////
// WEBPACK FOOTER
// ../falcon-plugins/plugin-falcon-journey/dist/components/annual/PremiumChoiceComponent.js
// module id = 727
// module chunks = 0